<script lang="ts" setup>
import { ToolAction } from "@/types/toolbox"
import { useAppFlasher, useBaseAPIGet } from "@xy-planning-network/trees"
import { computed, ref } from "vue"

const props = defineProps<{
  actions: ToolAction[]
}>()

const action = ref<string>("")
const actionRunning = ref<boolean>(false)
const actionEndpoint = computed(() => {
  const endpoint = props.actions.find((t) => t.name === action.value)
  return endpoint?.url || ""
})

const runAction = () => {
  if (actionEndpoint.value === "") {
    return
  }

  const { isLoading, execute } = useBaseAPIGet(actionEndpoint.value, {
    withDelay: 500,
  })

  actionRunning.value = isLoading.value
  execute()
    .then(() => {
      window.location.reload()
    })
    .catch(() => {
      useAppFlasher.error(
        "Whoops! We couldn't run that action.  Trying refreshing the page and running it again."
      )
    })
}
</script>

<template>
  <div class="space-y-3">
    <Select
      v-model="action"
      label="Select Action to Run"
      :options="
        actions.map((t) => {
          return { label: t.name, value: t.name }
        })
      "
    />

    <button
      class="xy-btn"
      :disabled="actionEndpoint === '' || actionRunning"
      @click="runAction"
    >
      Run Action
    </button>
  </div>
</template>
